import { render, staticRenderFns } from "./AllCustomerComponent.vue?vue&type=template&id=01a39bc8&"
import script from "./AllCustomerComponent.vue?vue&type=script&lang=js&"
export * from "./AllCustomerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports